export default __webpack_public_path__ + "bc97164a77fdf6276d8e78714d36e284.png";